import ApiBase from '@pulse/services/ApiBase';

export default class MerchantService extends ApiBase {
  constructor(apiBaseUrl) {
    super(apiBaseUrl);
  }

  async find(storeId) {
    const { data } = await this.client.get(`customer-portal/stores/${storeId}?include=coverageRules`);

    return data;
  }

  async findBySlug(slug) {
    const { data } = await this.client.get(`customer-portal/stores/slug?slug=${slug}`);

    return data;
  }
}
